var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"banner"}},[_c('div',{staticClass:"content"},[_c('h2',[_vm._v(_vm._s(_vm.$t('welcome')))]),_c('p',[_vm._v(_vm._s(_vm.$t('home_message')))])])])}
var staticRenderFns = []

export { render, staticRenderFns }